{ AceEditor, Modal, Window } from @danielx/dui

Jadelet from jadelet

{ JUDGMENT_COLORS, ROLL_BG_COLOR } from ../const.civet

defaultThemeValues :=
  showMeasureNumbers: true
  staffAlpha: 1
  // TODO: lyrics and text colors
  // lyricsColor: 0x202020
  minimapVisible: true
  playheadVisible: true

numberToColor := (n: number) ->
  "#" + n.toString(16).padStart(6, "0")

colorToNumber := (c: string) ->
  parseInt c.substr(1), 16

// self is player here
export ThemeEditor := (self: Player) ->
  { initSession, modeFor } := AceEditor

  BooleanInput := Jadelet.exec """
    label
      h3 @title
      input(type="checkbox" @name @checked)
  """

  NumberInput := Jadelet.exec """
    label
      h3 @title
      input(type="number" @name @value @min @max @step)
  """

  ColorInput := Jadelet.exec """
    label
      h3 @title
      input(type="color" @name @value)
  """

  inputElements := ->
    themeValues := Object.assign {}, defaultThemeValues, self.song.theme()

    [
      NumberInput
        title: "Staff Alpha"
        name: "staffAlpha"
        value: themeValues.staffAlpha
        step: 0.025
        min: 0
        max: 1
      BooleanInput
        title: "Playhead Visible"
        name: "playheadVisible"
        checked: themeValues.playheadVisible
      BooleanInput
        title: "Show Measure Numbers"
        name: "showMeasureNumbers"
        checked: themeValues.showMeasureNumbers
      BooleanInput
        title: "Show Minimap"
        name: "minimapVisible"
        checked: themeValues.minimapVisible
      // Practice/game visuals: roll backdrop and the judgment palette (the
      // hit-burst particles inherit the judgment colors)
      ColorInput
        title: "Roll Background"
        name: "rollBackground"
        value: numberToColor themeValues.rollBackground ?? ROLL_BG_COLOR
      ColorInput
        title: "Judgment: Perfect"
        name: "judgmentPerfect"
        value: numberToColor themeValues.judgmentColors?.perfect ?? JUDGMENT_COLORS.perfect
      ColorInput
        title: "Judgment: Good"
        name: "judgmentGood"
        value: numberToColor themeValues.judgmentColors?.good ?? JUDGMENT_COLORS.good
      ColorInput
        title: "Judgment: Early/Late"
        name: "judgmentOff"
        value: numberToColor themeValues.judgmentColors?.early ?? JUDGMENT_COLORS.early
      ColorInput
        title: "Judgment: Wrong"
        name: "judgmentWrong"
        value: numberToColor themeValues.judgmentColors?.wrong ?? JUDGMENT_COLORS.wrong
      ColorInput
        title: "Judgment: Miss"
        name: "judgmentMiss"
        value: numberToColor themeValues.judgmentColors?.miss ?? JUDGMENT_COLORS.miss
    ]

  Template := Jadelet.exec """
    form.theme
      h2 Theme

      p More theming options coming soon! Feedback is appreciated.

      @inputElements

      actions
        button OK
        button(click=@cancel) Cancel
  """

  Object.assign self,
    showThemeModal: ->
      r := await Modal.form Template
        inputElements: inputElements
        cancel: (e: Event) ->
          e.preventDefault()
          Modal.hide()

      return unless r

      // TODO: colors
      // r.lyricsColor = colorToNumber r.lyricsColor
      // r.staffBgColor = colorToNumber r.staffBgColor

      r.showMeasureNumbers = !!r.showMeasureNumbers
      r.minimapVisible = !!r.minimapVisible
      r.playheadVisible = !!r.playheadVisible
      r.staffAlpha = parseFloat(r.staffAlpha)

      r.rollBackground = colorToNumber r.rollBackground
      // early and late share the one "off timing" swatch
      off := colorToNumber r.judgmentOff
      r.judgmentColors =
        perfect: colorToNumber r.judgmentPerfect
        good: colorToNumber r.judgmentGood
        early: off
        late: off
        wrong: colorToNumber r.judgmentWrong
        miss: colorToNumber r.judgmentMiss
      delete r.judgmentPerfect
      delete r.judgmentGood
      delete r.judgmentOff
      delete r.judgmentWrong
      delete r.judgmentMiss

      self.song.theme r

export default ThemeEditor
